'use client'

import s from './page.module.scss';
import {Container} from "@/app/[locale]/common/components/Container/Container";
import {Breadcrumbs} from "@/app/[locale]/common/components/Breadcrumbs/Breadcrumbs";
import {TitleImageSection} from "@/app/[locale]/common/components/TitleImageSection/TitleImageSection";
import main from '@/app/[locale]/common/assets/images/slider-main/slide_3.webp';
import {ContactUs} from "@/app/[locale]/common/components/ContactUs/ContactUs";
import React from "react";
import {Title} from "@/app/[locale]/common/components/Title/Title";
import {TTasksCardContent} from "@/app/[locale]/industries/types";
import {TaskCard} from "@/app/[locale]/common/components/TaskCard/TaskCard";
import {ConfirmIcon} from "@/app/[locale]/common/assets/ConfirmIcon/ConfirmIcon";
import {ELEMENT_INDEX} from "../../common/constants/app";
import {ParagraphLine} from "@/app/[locale]/common/components/ParagraphLine/ParagraphLine";
import Image from "next/image";
import telematics_hardware from '../../common/assets/images/industires/logistics/telematics-hardware.webp';
import fuel_volume_monitoring from '../../common/assets/images/industires/logistics/fuel-volume-monitoring.webp';
import volume_graph from '../../common/assets/images/industires/logistics/volume-graph.webp';
import fuel_consumption from '../../common/assets/images/industires/logistics/fuel-consumption.webp';
import consumption_graph from '../../common/assets/images/industires/logistics/consumption-graph.webp';
import {SliderBlock} from "@/app/[locale]/common/components/SliderBlock/SliderBlock";
import {DieselGeneratorSlideCard} from "@/app/[locale]/common/components/DieselGeneratorSlideCard/DieselGeneratorSlideCard";
import {TDieselGeneratorSlideCardProps} from "@/app/[locale]/common/components/DieselGeneratorSlideCard/types";
import {ListCard} from "@/app/[locale]/common/components/ListCard/ListCard";
import {useTranslations} from "next-intl";
import {TimeTrackingIcon} from "@/app/[locale]/common/assets/TimeTrackingIcon/TimeTrackingIcon";
import {SpeedIcon} from "@/app/[locale]/common/assets/SpeedIcon/SpeedIcon";
import {FuelVolumeIcon} from "@/app/[locale]/common/assets/FuelVolumeIcon/FuelVolumeIcon";
import {EngineCheckIcon} from "@/app/[locale]/common/assets/EngineCheckIcon/EngineCheckIcon";
import {AxleLoadIcon} from "@/app/[locale]/common/assets/AxleLoadIcon/AxleLoadIcon";
import {NumOneCircleIcon} from "@/app/[locale]/common/assets/NumOneCircleIcon/NumOneCircleIcon";
import {NumTwoCircleIcon} from "@/app/[locale]/common/assets/NumTwoCircleIcon/NumTwoCircleIcon";
import {NumTreeCircleIcon} from "@/app/[locale]/common/assets/NumTreeCircleIcon/NumTreeCircleIcon";
import {NumFourCircleIcon} from "@/app/[locale]/common/assets/NumFourCircleIcon/NumFourCircleIcon";
import {NumFiveCircleIcon} from "@/app/[locale]/common/assets/NumFiveCircleIcon/NumFiveCircleIcon";
import slide1_logistics from "@/app/[locale]/common/assets/images/industires/logistics/slider/slide1-logistics.webp";
import slide2_logistics from "@/app/[locale]/common/assets/images/industires/logistics/slider/slide2-logistics.webp";

export default function Logistics() {
    const t = useTranslations('LogisticsPage');

    const tasksCardsIcons = [TimeTrackingIcon, SpeedIcon, FuelVolumeIcon, EngineCheckIcon, AxleLoadIcon];
    const tasksCards = t.raw('tasksBlock.cardsData').map((item: {title: string}, index: number) => ({...item, Icon: tasksCardsIcons[index]}));

    const telematicFeaturesIcons = [NumOneCircleIcon, NumTwoCircleIcon, NumTreeCircleIcon, NumFourCircleIcon, NumFiveCircleIcon];
    const telematicFeaturesCards = t.raw('telematicFeaturesBlock.cardsData').map((item: {title: string}, index: number) => ({...item, Icon: telematicFeaturesIcons[index]}));

    const casesImages = [slide1_logistics, slide2_logistics];
    const casesCards = t.raw('cases.data').map((item: { task: string, solution: string, label: string }, index: number) => ({...item, image: casesImages[index]}));

    return (
        <div className={s.logistics}>
            <Container>
                <Breadcrumbs crumb={[t.raw('breadcrumbs.INDUSTRIES'), t.raw('breadcrumbs.LOGISTICS')]}/>
                <TitleImageSection
                    title={t('title')}
                    image={main}
                />

                <div className={s.logistics_tasks}>
                    <Title title={t('tasksBlock.title')}/>

                    <div className={s.logistics_cardsContainer}>
                        {
                            tasksCards.map((item: TTasksCardContent, index: number) => (
                                <TaskCard
                                    key={index}
                                    Icon={item.Icon}
                                    title={item.title}
                                />
                            ))
                        }
                    </div>

                    <div className={`${s.logistics_tasks_textCard} ${s.logistics_flexContainer}`}>
                        <div className={s.logistics_tasks_textCard_text}>
                            {
                                t.raw('tasksBlock.text').map((item: string, index: number) => (
                                    <React.Fragment key={index}>
                                        {index === ELEMENT_INDEX.FIRST ?
                                            <ParagraphLine>{ item }</ParagraphLine> :
                                            <p>{ item }</p>}
                                    </React.Fragment>
                                ))
                            }
                        </div>

                        <ListCard data={t.raw('tasksBlock.listCardData')} pointIcon={<span><ConfirmIcon/></span>}/>
                    </div>
                </div>

                <div className={s.logistics_hardware}>
                    <Title title={t('hardwareBlock.title')} />

                    <div className={s.logistics_hardware_imageContainer}>
                        <Image src={telematics_hardware} alt={'telematics_hardware'} />
                    </div>
                </div>

                <div className={s.logistics_telematicFeatures}>
                    <Title title={t('telematicFeaturesBlock.title')} />

                    <div className={s.logistics_cardsContainer}>
                        {
                            telematicFeaturesCards.map((item: TTasksCardContent, index: number) => (
                                <TaskCard
                                    key={index}
                                    Icon={item.Icon}
                                    title={item.title}
                                />
                            ))
                        }
                    </div>

                    <div className={`${s.logistics_telematicFeatures_volume} ${s.logistics_flexContainer}`}>
                        <div className={s.logistics_telematicFeatures_volume_imageContainer}>
                            <Image src={fuel_volume_monitoring} alt={'fuel_volume_monitoring'} />
                        </div>

                        <div className={`${s.logistics_card} ${s.logistics_volumeCard}`}>
                            <label>{ t('telematicFeaturesBlock.volumeCard.label') }</label>
                            <p>{ t('telematicFeaturesBlock.volumeCard.title') }</p>
                            <div className={s.logistics_card_list}>
                                {
                                    t.raw('telematicFeaturesBlock.volumeCard.list').map((item: string, index: number) => (
                                        <ul key={index}>
                                            <li className={s.logistics_card_item}>
                                                <span><ConfirmIcon/></span>
                                                {item}
                                            </li>
                                        </ul>
                                    ))
                                }
                            </div>
                        </div>
                    </div>

                    <div className={s.logistics_telematicFeatures_volumeGraphImageContainer}>
                        <Image src={volume_graph} alt={'volume_graph'} />
                    </div>
                    <p className={s.logistics_telematicFeatures_volumeText}>{ t('telematicFeaturesBlock.volumeText') }</p>

                    <div className={`${s.logistics_telematicFeatures_consumption} ${s.logistics_flexContainer}`}>
                        <div className={`${s.logistics_card} ${s.logistics_consumptionCard}`}>
                            <label>{ t('telematicFeaturesBlock.consumptionCard.label') }</label>
                            <p className={s.logistics_consumptionCard_title}>{ t('telematicFeaturesBlock.consumptionCard.title') }</p>
                            <div className={s.logistics_card_list}>
                                {
                                    t.raw('telematicFeaturesBlock.consumptionCard.list').map((item: string, index: number) => (
                                        <ul key={index}>
                                            <li className={s.logistics_card_item}>
                                                <span><ConfirmIcon/></span>
                                                {item}
                                            </li>
                                        </ul>
                                    ))
                                }
                            </div>
                            <p className={s.logistics_consumptionCard_note}>{ t('telematicFeaturesBlock.consumptionCard.consumptionCardNote') }</p>
                        </div>

                        <div className={s.logistics_telematicFeatures_consumption_imageContainer}>
                            <Image src={fuel_consumption} alt={'fuel_consumption'} />
                        </div>
                    </div>

                    <div className={s.logistics_telematicFeatures_volumeGraphImageContainer}>
                        <Image src={consumption_graph} alt={'consumption_graph'} />
                    </div>
                    <p className={s.logistics_telematicFeatures_volumeText}>{ t('telematicFeaturesBlock.volumeSecondText') }</p>
                </div>

                <SliderBlock
                    label={t('cases.title')}
                    navigationId={'cases'}
                    data={casesCards}
                    card={(item, index) => (
                        <DieselGeneratorSlideCard
                            key={index}
                            label={item.label}
                            task={(item as TDieselGeneratorSlideCardProps).task}
                            solution={(item as TDieselGeneratorSlideCardProps).solution}
                            image={(item as TDieselGeneratorSlideCardProps).image}
                        />
                    )}
                />

                <ContactUs/>
            </Container>
        </div>
    );
};